/**
 * Dual relay device template
 * Used by: SPSW-002PE16EU
 */

import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import { createPowerLevelCondition, createPowerThresholdTrigger } from '../../common/powerMonitoring.js';
import { anyChannel, allChannels } from '../../../utils/channelHelpers.js';

export function createDualRelayTemplate() {
	const base = {
		deviceType: 'dual_relay',
		channels: ['switch:0', 'switch:1'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
			powerLevel: createPowerLevelCondition(3680),
			// Dual-specific conditions
			anyChannelOn: {
				name: 'Any Channel Active',
				description: 'Check if any relay channel is currently on',
				parameters: {},
				evaluateCondition: (device, channel, params) => {
					return anyChannel(
						device.status,
						['switch:0', 'switch:1'],
						(ch) => ch?.output === true,
					);
				},
			},
			allChannelsOn: {
				name: 'All Channels Active',
				description: 'Check if all relay channels are currently on',
				parameters: {},
				evaluateCondition: (device, channel, params) => {
					return allChannels(
						device.status,
						['switch:0', 'switch:1'],
						(ch) => ch?.output === true,
					);
				},
			},
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			powerThreshold: createPowerThresholdTrigger(3680),
			// Dual-specific trigger
			anyChannelChanged: {
				name: 'Any Channel State Changed',
				description: 'Fires when any relay channel changes state',
				parameters: {},
				detectTrigger: (previousState, currentState, channel, params) => {
					const prev0 = previousState?.status?.['switch:0']?.output;
					const curr0 = currentState?.status?.['switch:0']?.output;
					const prev1 = previousState?.status?.['switch:1']?.output;
					const curr1 = currentState?.status?.['switch:1']?.output;

					return prev0 !== curr0 || prev1 !== curr1;
				},
			},
		},
	};

	return base;
}
